import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Link,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDeniedModal = () => {
    const navigate = useNavigate();

    const onClick = () => {
        navigate('/reservations');
    };

    return (
        <Dialog open={true}>
            <DialogTitle>
                Access Restricted
                <IconButton
                    onClick={() => navigate(-1)}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2, // controls spacing between Typography blocks
                }}
            >
                <Typography variant='body2' fontWeight='bold'>
                    You don’t currently have access to view or book experiences
                    on 7DAY.
                </Typography>

                <Typography variant='body2'>
                    It looks like you don’t have an account yet — reach out to
                    our team at{' '}
                    <Link href='mailto:support@7-day.com'>
                        support@7-day.com
                    </Link>{' '}
                    and we’ll help get you set up.
                </Typography>

                <Typography variant='body2'>
                    Click{' '}
                    <Link
                        component='button'
                        onClick={onClick}
                        sx={{
                            p: 0,
                            minWidth: 'auto',
                            display: 'inline',
                            verticalAlign: 'baseline',
                            font: 'inherit',
                            lineHeight: 'inherit',
                        }}
                    >
                        here
                    </Link>{' '}
                    to view your reservations.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button variant='contained' onClick={() => navigate(-1)}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AccessDeniedModal;
